import {
  MODE_OF_DELIVERY,
  MODE_OF_DELIVERY_LABELS,
  PAYMENT_STATUS,
  PAYMENT_STATUS_LABELS,
  TRANSACTION_TYPES,
  TRANSACTION_TYPE_LABELS,
} from '../../../../services/purchaseDealSheetService';

export const PAYMENT_STATUS_COLORS = {
  UNPAID: 'gold',
  PARTIAL: 'orange',
  PAID: 'green',
};

export const TRANSACTION_TYPE_OPTIONS = TRANSACTION_TYPES.map((value) => ({
  value,
  label: TRANSACTION_TYPE_LABELS[value],
}));

export const MODE_OF_DELIVERY_OPTIONS = MODE_OF_DELIVERY.map((value) => ({
  value,
  label: MODE_OF_DELIVERY_LABELS[value],
}));

export const PAYMENT_STATUS_OPTIONS = PAYMENT_STATUS.map((value) => ({
  value,
  label: PAYMENT_STATUS_LABELS[value],
}));

export const PAYMENT_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All statuses' },
  ...PAYMENT_STATUS_OPTIONS,
];

export const TRANSACTION_TYPE_FILTER_OPTIONS = [
  { value: '', label: 'All types' },
  ...TRANSACTION_TYPE_OPTIONS,
];

export const CREATE_STEPS = [
  { title: 'Deal' },
  { title: 'Details' },
  { title: 'Payment' },
];

export const SUPPLIER_SEARCH_MIN = 3;
export const PRODUCT_SEARCH_MIN = 1;

export const SELLER_SNAPSHOT_FIELDS = [
  { key: 'seller_name', label: 'Name' },
  { key: 'seller_pan', label: 'PAN' },
  { key: 'seller_bank_name', label: 'Bank Name' },
  { key: 'seller_account_number', label: 'Account Number' },
  { key: 'seller_ifsc_code', label: 'IFSC' },
  { key: 'seller_dp_name', label: 'DP Name' },
  { key: 'seller_dp_id', label: 'DP ID' },
  { key: 'seller_client_id', label: 'Client ID' },
];

export const BUYER_SNAPSHOT_FIELDS = [
  { key: 'buyer_name', label: 'Name' },
  { key: 'buyer_pan', label: 'PAN' },
  { key: 'buyer_bank_name', label: 'Bank Name' },
  { key: 'buyer_account_number', label: 'Account Number' },
  { key: 'buyer_ifsc', label: 'IFSC' },
  { key: 'buyer_dp_name', label: 'DP Name' },
  { key: 'buyer_dp_id', label: 'DP ID' },
  { key: 'buyer_client_id', label: 'Client ID' },
];
